import havaAbi from "./abis/hava.json";

const abis = {
  hava: havaAbi,
};

export default abis;
